function Zone() {
    "use strict";

    this.__type = 'Zone:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.AgentId = -1;
    this.UpdatedByAppUserId = -1;
    this.BadEventCount = 0;
    this.CenterLatitude = 0;
    this.CenterLongitude = 0;
    this.Description = '';
    this.EnrolleeCount = 0;
    this.GlobalZoneId = -1;
    this.GoodEventCount = 0;
    this.IsActive = 1;
    this.IsVisible = true;
    this.Name = '';
    this.OrganizationId = -1;
    this.Radius = 250;
    this.Scope = 1;
    this.Shape = 1;
    this.Type = -1;
    this.TransactionId = moment().format("YYYYMMDDHHmmss");
    this.ZoneClassificationId = -1;
    this.AddressTypeId = -1;
    this.AoiZoneEnable = false;
    this.CreatedDateUTC = (new Date()).toWcf();
    this.OrderIndex = '';
    this.VertexLatitude = '';
    this.VertexLongitude = '';
    this.IsVertexActive = '';
    this.IsLast = '';
    this.VertexId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = Zone;
}